import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

// Your Firebase configuration object (from the Firebase Console)
const firebaseConfig = {
  apiKey: 'AIzaSyCHqJvN4VRtN9JxKkgC1if78hhQe7GVaFY',
  authDomain: 'ipdc-4836b.firebaseapp.com',
  projectId: 'ipdc-4836b',
  storageBucket: 'ipdc-4836b.firebasestorage.app',
  messagingSenderId: '649409502794',
  appId: '1:649409502794:web:ff464362a0e62a483450b3',
  measurementId: 'G-KPRK5BESCH',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firestore
const db = getFirestore(app)

export default db
